import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store";
import {
  DashboardFilterType,
  DashboardState,
  DashboardTransactionsDetail,
  DelayedTrip,
  PointDetail,
  SlotCapacity,
  Saturation,
} from "./types/dashboard";
import { DASHBOARD_TABLES_LIMIT } from "utils/constants";

export const initialState: DashboardState = {
  dashboard: {
    transactionsDetail: {
      active: 0,
      assigned: 0,
      collected: 0,
      inDelay: 0,
    },
    delayedTrips: [],
    tripsQuantity: 0,
    tripsCurrentPage: 0,
    points: [],
    pointsQuantity: 0,
    pointsCurrentPage: 0,
    saturation: [],
    slotCapacity: [],
  },
  filters: {},
  previousFilters: {},
  isSingleRegion: false,
};

const SLICE_NAME = "dashboard";

export const dashboardSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    getDashboard: (state, action: PayloadAction<DashboardFilterType>) => {
      state.isSingleRegion = action.payload.regions?.split(",").length === 1;
      state.dashboard.tripsCurrentPage = 0;
    },
    setDashboardFilters: (
      state,
      action: PayloadAction<DashboardFilterType>
    ) => {
      state.previousFilters = state.filters;
      state.filters = action.payload;
    },
    getSlotCapacityRequest: (
      state,
      action: PayloadAction<DashboardFilterType>
    ) => {},
    getSlotCapacityError: (state) => {
      state.dashboard.slotCapacity = [];
    },
    getSlotCapacitySuccess: (state, action: PayloadAction<SlotCapacity[]>) => {
      state.dashboard.slotCapacity = action.payload;
    },
    getDelayedTripsRequest: (
      state,
      action: PayloadAction<DashboardFilterType>
    ) => {},
    getDelayedTripsError: (state) => {
      state.dashboard.delayedTrips = [];
    },
    getDelayedTripsSuccess: (
      state,
      action: PayloadAction<{ details: DelayedTrip[]; quantity: number }>
    ) => {
      state.dashboard.delayedTrips = action.payload.details;
      state.dashboard.tripsQuantity = action.payload.quantity;
    },
    getPointStatusRequest: (
      state,
      action: PayloadAction<DashboardFilterType>
    ) => {
      state.dashboard.pointsCurrentPage =
        action.payload.offset! / DASHBOARD_TABLES_LIMIT;
    },
    getPointStatusError: (state) => {
      state.dashboard.points = [];
    },
    getPointStatusSuccess: (
      state,
      action: PayloadAction<{ details: PointDetail[]; quantity: number }>
    ) => {
      state.dashboard.points = action.payload.details;
      state.dashboard.pointsQuantity = action.payload.quantity;
    },
    getTransactionsDetailRequest: (
      state,
      action: PayloadAction<DashboardFilterType>
    ) => {},
    getTransactionsDetailError: (state) => {},
    getTransactionsDetailSuccess: (
      state,
      action: PayloadAction<DashboardTransactionsDetail>
    ) => {
      state.dashboard.transactionsDetail = action.payload;
    },
    getSaturationRequest: (
      state,
      action: PayloadAction<DashboardFilterType>
    ) => {},
    getSaturationError: (state) => {
      state.dashboard.saturation = [];
    },
    getSaturationSuccess: (state, action: PayloadAction<Saturation[]>) => {
      state.dashboard.saturation = action.payload;
    },
    resetFilter: (state) => {
      state.filters = {};
    },
    setTripPage: (state, action: PayloadAction<number>) => {
      state.dashboard.tripsCurrentPage = action.payload;
    },
  },
});

export const dashboardSelector = (state: RootState) => state.dashboard;

export const actions = dashboardSlice.actions;

export default dashboardSlice.reducer;
